module.exports = __webpack_public_path__ + "img/razor.04b60342.png";